import { useTranslation } from "react-i18next";
import StreakIndicator from "./StatusCardComponents/StreakIndicator";

const EMPTY_WEEK = Array(7).fill(false);

// StatsCard consits of 3 Rows:
// Title + Icon
// Value (and unit or out of)
// bottomBar (e.g. streak indicator)
const StatsCard = ({ type, value, activityArray = EMPTY_WEEK }) => {
    const { t } = useTranslation();
    let title;
    let icon;
    let bottombar;
    let unit;

    switch (type) {
        case "streak":
            title = t("statscard.streak");
            icon = (
                <svg
                    className="fill-orange-500"
                    viewBox="0 0 16 16"
                    xmlns="http://www.w3.org/2000/svg"
                    id="Fire-Fill--Streamline-Remix-Fill"
                    height="16"
                    width="16"
                >
                    <desc>Streak Icon</desc>
                    <path
                        d="M8 15.333333333333332c-2.761426666666667 0 -5 -2.2386 -5 -5 0 -1.4358666666666666 0.60524 -2.7303333333333333 1.5745266666666666 -3.6422666666666665C5.469353333333332 5.849166666666666 7.666666666666666 4.333006666666666 7.333333333333333 1c4 2.6666666666666665 6 5.333333333333333 2 9.333333333333332 0.6666666666666666 0 1.6666666666666665 0 3.333333333333333 -1.6469333333333334 0.1798 0.5157333333333333 0.3333333333333333 1.0699333333333332 0.3333333333333333 1.6469333333333334 0 2.7614 -2.2386 5 -5 5Z"
                        stroke-width="0.6667"
                    ></path>
                </svg>
            );
            bottombar = <StreakIndicator sevenDayBooleanArray={activityArray} />;
            unit = t("unit.days");
            break;

        case "score":
            title = t("statscard.score");
            icon = (
                <svg
                    className="fill-yellow-400"
                    viewBox="0 0 16 16"
                    xmlns="http://www.w3.org/2000/svg"
                    id="Trophy-Fill--Streamline-Remix-Fill"
                    height="16"
                    width="16"
                >
                    <desc>Trophy Icon</desc>
                    <path
                        d="M8.669933333333333 11.293933333333332v1.3745333333333332h3.333333333333333v1.3333333333333333H4.003253333333333v-1.3333333333333333h3.3333466666666665v-1.3745333333333332c-2.6308866666666666 -0.3280666666666666 -4.6666799999999995 -2.572333333333333 -4.6666799999999995 -5.2921v-4H13.336599999999999v4c0 2.7197666666666667 -2.0358 4.964033333333333 -4.666666666666666 5.2921ZM0.66992 3.3351666666666664h1.3333333333333333v2.6666666666666665h-1.3333333333333333v-2.6666666666666665Zm13.333346666666666 0h1.3333333333333333v2.6666666666666665h-1.3333333333333333v-2.6666666666666665Z"
                        stroke-width="0.6667"
                    ></path>
                </svg>
            );
            unit = t("unit.points");
            break;

        case "sentences":
            title = t("statscard.sentences");
            icon = (
                <svg
                    className="fill-primary"
                    viewBox="0 0 16 16"
                    xmlns="http://www.w3.org/2000/svg"
                    id="Speak-Fill--Streamline-Remix-Fill"
                    height="16"
                    width="16"
                >
                    <desc>Speak Icon</desc>
                    <path
                        d="M6 1.3333333333333333c2.7116666666666664 0 4.950666666666667 2.023746666666667 5.289133333333333 4.643293333333333l1.5003333333333333 2.359173333333333c0.0988 0.15533333333333332 0.07886666666666667 0.3873333333333333 -0.1499333333333333 0.4853333333333333L11.333333333333332 9.380666666666666V11.333333333333332c0 0.7363999999999999 -0.5969333333333333 1.3333333333333333 -1.3333333333333333 1.3333333333333333h-1.3326666666666667L8.666666666666666 14.666666666666666H2.6666666666666665l0.00016666666666666666 -2.4626c0.00005333333333333333 -0.7872666666666667 -0.29116 -1.5316 -0.8298333333333333 -2.203333333333333C1.1047133333333332 9.087533333333333 0.6666666666666666 7.928266666666667 0.6666666666666666 6.666666666666666c0 -2.94552 2.387813333333333 -5.333333333333333 5.333333333333333 -5.333333333333333Zm8.102333333333332 10.734933333333332 -1.1094666666666666 -0.7396666666666666C13.629066666666667 10.376133333333332 14 9.231399999999999 14 8.000066666666665c0 -1.2313999999999998 -0.37093333333333334 -2.376133333333333 -1.0071333333333332 -3.328586666666667l1.1094666666666666 -0.7396733333333333C14.879999999999999 5.095906666666666 15.333333333333332 6.495026666666666 15.333333333333332 8.000066666666665c0 1.505 -0.45333333333333337 2.904066666666666 -1.2309999999999999 4.068199999999999Z"
                        stroke-width="0.6667"
                    ></path>
                </svg>
            );
            unit = "/ 10";
            break;

        case "practice":
            title = t("statscard.practice");
            icon = (
                <svg
                    className="fill-blue-400"
                    viewBox="0 0 16 16"
                    fill="blue"
                    xmlns="http://www.w3.org/2000/svg"
                    id="Time-Fill--Streamline-Remix-Fill"
                    height="16"
                    width="16"
                >
                    <desc>Time Icon</desc>
                    <path
                        d="M8 14.666666666666666C4.318099999999999 14.666666666666666 1.3333333333333333 11.681866666666666 1.3333333333333333 8 1.3333333333333333 4.318099999999999 4.318099999999999 1.3333333333333333 8 1.3333333333333333c3.6818666666666666 0 6.666666666666666 2.9847666666666663 6.666666666666666 6.666666666666666 0 3.6818666666666666 -2.9848 6.666666666666666 -6.666666666666666 6.666666666666666Zm0.6666666666666666 -6.666666666666666V4.666666666666666h-1.3333333333333333v4.666666666666666h4v-1.3333333333333333h-2.6666666666666665Z"
                        strokeWidth="0.6667"
                    ></path>
                </svg>
            );
            unit = t("unit.minutesAbbreviation");
            bottombar = <p className="text-xs text-gray-500">{t("DailyGoal5Minutes")}</p>;
            break;

        default:
            title = "Oops this is a test card";
    }

    return (
        <div className="border border-gray-300 rounded-lg p-3 flex-col h-full">
            {/* title and Icon */}
            <div className="flex justify-between">
                <h3 className="font-medium text-xs">{title}</h3>
                {icon}
            </div>

            {/* value and unit */}
            <div className="mt-4 flex items-center">
                <p className="text-3xl font-medium">{value ?? "—"}</p>
                <p className="text-2xl text-gray-400 pl-2">{unit}</p>
            </div>

            {/* bottomBar (e.g. streak indicator) */}
            <div className="mt-2">{bottombar}</div>
        </div>
    );
};

export default StatsCard;
